import { render, staticRenderFns } from "./AddQualification.vue?vue&type=template&id=57e8023b"
import script from "./AddQualification.vue?vue&type=script&lang=js"
export * from "./AddQualification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports